<!-- display-mobile-20 preview — the filled sibling of placement 19: a dark
     gradient card in the middle of an article carrying an oversized cyan
     headline, then the description beside a cyan circular button, with the
     disclosure badge and the advertiser name below the card rather than in it. -->
<app-mobile-frame>
  <app-display-browser-chrome frameTop></app-display-browser-chrome>

  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- Article text the ad is embedded in -->
    <div class="da-bars d-flex flex-column">
      <span
        *ngFor="let bar of topBars; let last = last"
        class="da-bar placeholder"
        [class.da-bar-short]="last"
      ></span>
    </div>

    <!-- START: Real ad -->
    <div class="da-ad">
      <!-- The mock draws no creative in this placement, so data.image has
           nowhere to go: the card is all type plus the action button. -->
      <div class="da-unit d-flex flex-column">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
          {{ data.headlines[0] || "Your headline appears here" }}
        </a>

        <div class="da-row d-flex flex-row align-items-center">
          <div class="da-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>

          <a
            [href]="data.url" target="_blank" rel="noopener noreferrer"
            class="da-cta d-flex align-items-center justify-content-center"
            aria-label="Open"
          >
            <!-- Drawn rather than taken from bootstrap-icons: the mock's chevron
                 carries a far heavier stroke than the icon set has, and at this
                 size that weight is the whole character of the button. The
                 viewBox is the mock's own ink box, in its pixels. -->
            <svg
              class="da-cta-icon"
              viewBox="0 0 13 24"
              fill="none"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M2.1 2.1 10.9 12l-8.8 9.9"
                stroke="currentColor"
                stroke-width="4.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </div>
      </div>

      <!-- Below the card, not inside it — the network's own chrome, drawn on the
           page rather than on the unit. -->
      <div class="da-footer d-flex flex-row align-items-center">
        <span
          class="da-adchoices d-flex align-items-center justify-content-center"
          aria-hidden="true"
        >
          <i class="bi bi-info-circle"></i>
        </span>

        <!-- GenSingleImagePreviewData carries no advertiser field, so the name
             is a literal here, the same compromise the other placements make. -->
        <span class="da-advertiser ms-auto">Valamar</span>
      </div>
    </div>
    <!-- END: Real ad -->

    <!-- Article text continuing below the ad; the last rows clip at the frame -->
    <div class="da-bars d-flex flex-column">
      <span *ngFor="let bar of bottomBars" class="da-bar placeholder"></span>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
